import React, { Component } from "react";
import {
    Row,
    Col
} from "reactstrap";

const UNIT_LABELS = {
    "L": "litre",
    "Kg": "kilogramme"
}

class OperationsOrdersOrderGasBlock extends Component{
    constructor(props){
        super(props);

        this.toggleVehicles = this.toggleVehicles.bind(this);

        this.state = {
            vehicles_toggeled: false
        };
    }

    toggleVehicles(){
        this.setState({vehicles_toggeled: !this.state.vehicles_toggeled});
    }

    render(){
        return (
            <div className="marg-t-10 blue_dark ty-order-gaz-block">
                <Row>
                    <Col md="6" xs="12">
                        <div className={"text-uppercase bold"} style={{color: this.props.color}}>{ this.props.name }</div>
                        <div className="pointer" onClick={this.toggleVehicles}>
                            { this.props.qty ? this.props.qty.toFixed(2) + ` ${this.props.unit} - ` : "" }
                            { this.props.vehicles.length } vehicule{ this.props.vehicles.length > 1 ? "s" : "" }
                            <i className={"marg-l-20 icon icon-chevron-" + (this.state.vehicles_toggeled ? "up" : "down")} aria-hidden="true"> </i>
                        </div>
                    </Col>
                    <Col md="6" xs="12">
                        {
                            this.props.price ?
                                <div className="float-right f-15 bold">
                                    { this.props.price } &euro; TTC
                                </div>
                                :
                                ""
                        }
                        <div className="text-uppercase bold gray_dark">Prix au {UNIT_LABELS[this.props.unit]}</div>
                        <div className="">{ this.props.unit_price } &euro;/{this.props.unit} TTC</div>
                    </Col>
                </Row>

                {
                    this.state.vehicles_toggeled ?
                        <Row className="marg-t-10">
                            <Col md="12">
                                <ul className="list-unstyled marg-b-0 marg-l-15">
                                    {
                                        this.props.vehicles.map((vehicle, i) => {
                                            return (
                                                <li key={i} className="d-flex pad-5 f-12 pad-b-0 ty-order-vehicle-line">
                                                    <div>
                                                        {
                                                            vehicle.description + " " +
                                                            vehicle.color + " - " +
                                                            vehicle.plate
                                                        }
                                                    </div>
                                                    {
                                                        vehicle.quantity_delivered ?
                                                            <div className="marg-l-20">
                                                                { vehicle.quantity_delivered } {this.props.unit}
                                                                { vehicle.km ? " - " + vehicle.km + " Km" : "" }
                                                            </div>
                                                            :
                                                            ""
                                                    }
                                                </li>
                                            );
                                        })
                                    }
                                </ul>
                            </Col>
                        </Row>
                        :
                        ""
                }
            </div>
        );
    }
}

OperationsOrdersOrderGasBlock.defaultProps = {
    vehicles: [],
    color: "inherit",
    name: "",
    unit_price: 0,
    price: 0,
    qty: 0,
    unit: "L"
};

export default OperationsOrdersOrderGasBlock;



// WEBPACK FOOTER //
// ./src/components/Operations/Order/GasBlock.js